import { useState } from "react";
import { EditableField, EditableImage } from "@/site/Editable";
import { useSite } from "@/site/SiteContext";
import { PageHead } from "@/site/pages/About";
import { Showroom } from "@/site/Showroom";

const Card = ({ p, onOpen }) => {
  const { saveProject } = useSite();
  return (
    <div className="hs-pcard hs-fade" role="button" tabIndex={0} onClick={onOpen} onKeyDown={(e) => e.key === "Enter" && onOpen()} data-testid={`portfolio-card-${p.id}`}>
      <EditableImage src={p.cover} alt={p.title} className="hs-frame hs-frame--light hs-pcard__img" onReplace={(cover) => saveProject(p.id, { cover })} testId={`portfolio-cover-${p.id}`} />
      <div className="hs-pcard__meta">
        <EditableField value={p.title} onSave={(title) => saveProject(p.id, { title })} as="h3" className="hs-pcard__title" multiline={false} testId={`portfolio-title-${p.id}`} />
        <EditableField value={p.location || " "} onSave={(location) => saveProject(p.id, { location })} as="span" className="hs-caption" multiline={false} testId={`portfolio-location-${p.id}`} />
      </div>
    </div>
  );
};

export default function Portfolio() {
  const { content } = useSite();
  const [openId, setOpenId] = useState(null);
  const project = content.projects.find((p) => p.id === openId);
  return (
    <>
      <PageHead titleKey="portfolio.heading" introKey="portfolio.intro" />
      <section className="hs-cream hs-portfolio" data-testid="portfolio-grid">
        <div className="hs-masonry">
          {content.projects.map((p) => <Card key={p.id} p={p} onOpen={() => setOpenId(p.id)} />)}
        </div>
      </section>
      {project && <Showroom project={project} onClose={() => setOpenId(null)} />}
    </>
  );
}
